<template>
  <l-marker
    v-if="markerIcon&&show"
    :lat-lng="markerPosition"
    :icon="markerIcon"
    @click="onClick"
  >
    <l-tooltip :options="{permanent:this.$props.tooltips}">{{this.$props.rettungspunktObj.RP_Nr}}</l-tooltip>
  </l-marker>
</template>

<script>
import { LMarker, LTooltip } from "@vue-leaflet/vue-leaflet";
import L from "leaflet";
import Swal from 'sweetalert2';

export default {
  name: "Rettungspunkt",
  components: { LMarker, LTooltip },
  props: {
    rettungspunktObj: Object,
    zoom: Number,
    markerPosition: Array,
    tooltips: Boolean,
  },
  data() {
    return {
      baseIconSize: 40, // Pixel bei Zoom 18
      markerIcon: L.icon({
        iconUrl: require("@/assets/KartenIcons/rettungspunkt.jpg"),
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -20],
        tooltipAnchor: [0, -40]
      }),
      show: true
    };
  },
  methods: {
    createIcon(zoom) {
      const size = this.baseIconSize * Math.pow(2, (zoom - 18) * 0.5);
      return L.icon({
        iconUrl: require("@/assets/KartenIcons/rettungspunkt.jpg"),
        iconSize: [size, size],
        iconAnchor: [size / 2, size],
        popupAnchor: [0, -size / 2],
        tooltipAnchor: [0, -size]
      });
    },
    onMapReady(map) {
      this.mapObject = map;
      map.invalidateSize();
    },
    onClick(){
        var footerText = '<a href="https://www.google.com/maps/place/' + this.$props.rettungspunktObj.position.y + '+' + this.$props.rettungspunktObj.position.x + '" target="_blank" style="color: black !important; font-family: Helvetica, Arial, sans-serif !important; text-decoration: none !important">Zu Google Maps </a>';
        console.log(this.$props.rettungspunktObj);
        let titleText = this.$props.rettungspunktObj.RP_Nr;
        Swal.fire({
            title: titleText,
            text: this.$props.rettungspunktObj.Ortsbeschr,
            footer: footerText
        })
    }
  },
  created() {
    this.markerIcon = this.createIcon(18);
  },
  mounted() {

  }
};
</script>

<style scoped>
.markerIcon{
    max-height: 2.5rem !important;
    filter: drop-shadow(0 0 0.05rem rgb(53, 53, 53));
}
</style>